<template>
  <div class="footer">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="footer-title">
            Get Started
          </div>
          <div class="footer-links">

            <div>
              <router-link :to="{'name':'users_signup'}">
                Signup
              </router-link>
            </div>
            <div>
              <router-link :to="{'name':'plans'}">
                Plans
              </router-link>
            </div>
            <div>
              <a href="#" @click.prevent="showCalendly()" >
                Schedule a Demo
              </a>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="footer-title">
            Resources
          </div>
          <div class="footer-links">
            <div>
              <router-link :to="{'name':'blog'}">
                Learn
              </router-link>
            </div>
            <div>
              <router-link :to="{'name':'methodology'}">
                Methodology
              </router-link>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="footer-title">
            Follow Us
          </div>
          <div class="footer-links">
            <div>
              <a href="https://twitter.com/startupfalcon" target="_blank">
                Twitter
              </a>
            </div>
            <div>
              <a href="https://www.facebook.com/startupfalcon" target="_blank">
                Facebook
              </a>
            </div>
            <div>
              <a href="https://www.youtube.com/channel/UCIJ0OFGV4HV1RaACMHsRFAw" target="_blank">
                Youtube
              </a>
            </div>
            <div>
              <a href="https://www.instagram.com/startupfalcon/" target="_blank">
                Instagram
              </a>
            </div>
            <div>
              <a href="https://www.linkedin.com/company/startup-falcon" target="_blank">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        <div class="column mail-widget">
         <div class="footer-title">
            Get Updates
          </div>

          <!-- Begin Mailchimp Signup Form -->
<div id="mc_embed_signup">
<form action="https://startupfalcon.us2.list-manage.com/subscribe/post?u=a4907b23f42230bdcbca5bac4&amp;id=dcf8df6482" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">
	<input type="email" value="" name="EMAIL" class="email input" id="mce-EMAIL"  placeholder="email address" required>

      <div class="sep-12"></div>
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_a4907b23f42230bdcbca5bac4_dcf8df6482" tabindex="-1" value=""></div>
      <div class="clear"><button  name="subscribe" id="mc-embedded-subscribe" class="button is-fullwidth">Subscribe</button></div>
    </div>
</form>
</div>

<!--End mc_embed_signup-->
        </div>
      </div>

      <div class="columns">
        <div class="column  term-of-user-links">
          <router-link :to="{'name': 'tos'}">
            Terms of Use
          </router-link>
          .
          <router-link :to="{'name': 'privacy'}">
            Privacy Policy
          </router-link>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="footer-sep"></div>
        </div>
      </div>
      <div class="columns footer-footer">
        <div class="column is-4">
          <img src="../../../images/logo_gray.svg" alt="">
        </div>
        <div class="column  is-4 cc text-center">
          548 Market St, PMB 52223, San Francisco, California, 94104, US
        </div>
        <div class="column  is-4 cc">
          © 2021 Startup Falcon All rights reserved.
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import mixins from "@/modules/landing-pages/mixins";

export default {
  name: "LandingFooter",
  mixins: [mixins]
}
</script>

<style lang="scss" scoped>
@import "../../../style/utils";

.footer {
  background-color: #232E3C;
}

.footer-title {
  @extend .font-bold;
  font-size: 20px;
  color: #fff;
  margin-bottom: 24px;
}

.footer-links {
  a {
    color: #7C828A;
  }
}

.term-of-user-links {
  a {
    color: #4E5963;
    font-size: 13px;
  }

}

.footer-sep {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #4E5963;
}

.footer-footer {
  font-size: 20px;
  color: #4E5963;

  .slogan {
    text-align: center;
  }

  .cc {
    text-align: right;
    font-size: 12px;
  }
  @include respond-to('mobile') {
    padding-bottom: 0 !important;

    .column {
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .cc {
      font-size: 10px;
    }

  }
}
.footer{
  @include respond-to('mobile') {
    padding-bottom: 20px !important;
  }
}
.mail-widget {
  input {
    border: 1px solid #CCD2D4;
    border-radius: 4px;
    background-color: #232E3C;
    color: #fff;

    &::placeholder {
      color: #fff;
    }
  }
}

</style>
